import { faArrowRotateRight } from '@fortawesome/pro-light-svg-icons/faArrowRotateRight'
import type { ExceptionTypes } from '@space-lib/components/exceptionState'
import ConectionError from '@space-shell/assets/images/conectionError.svg'
import EmptyState from '@space-shell/assets/images/empty.svg'
import InternalError from '@space-shell/assets/images/internalError.svg'
import NotFound from '@space-shell/assets/images/notFound.svg'

import type { TFunction } from 'react-i18next'

export type ExceptionProps = {
  exception:
    | 'notFound'
    | 'notFoundMembership'
    | 'empty'
    | 'emptyClub'
    | 'connectionError'
    | 'internalError'
    | 'serviceUnavailable'
  buttonAction?: () => void
}

type ExceptionsObjectProps = {
  notFound: ExceptionTypes
  notFoundMembership: ExceptionTypes
  empty: ExceptionTypes
  emptyClub: ExceptionTypes
  connectionError: ExceptionTypes
  internalError: ExceptionTypes
  serviceUnavailable: ExceptionTypes
}

export const useExceptions = (t: TFunction): ExceptionsObjectProps => ({
  notFound: {
    title: t('exception_state.not_found.title'),
    subtitle: t('exception_state.not_found.subtitle'),
    illustration: NotFound
  },
  notFoundMembership: {
    title: t('exception_state.not_found_membership.title'),
    subtitle: t('exception_state.not_found_membership.subtitle'),
    illustration: InternalError,
    textButton: t('exception_state.not_found_membership.text_button')
  },
  empty: {
    title: t('exception_state.empty.title'),
    subtitle: t('exception_state.empty.subtitle'),
    illustration: EmptyState
  },
  emptyClub: {
    title: t('exception_state.empty_club.title'),
    subtitle: t('exception_state.empty_club.subtitle'),
    illustration: EmptyState
  },
  connectionError: {
    title: t('exception_state.connection_error.title'),
    subtitle: t('exception_state.connection_error.subtitle'),
    illustration: ConectionError,
    textButton: t('exception_state.connection_error.text_button'),
    iconButton: faArrowRotateRight
  },
  internalError: {
    title: t('exception_state.internal_error.title'),
    subtitle: t('exception_state.internal_error.subtitle'),
    illustration: InternalError,
    textButton: t('exception_state.internal_error.text_button'),
    iconButton: faArrowRotateRight
  },
  serviceUnavailable: {
    title: t('exception_state.service_unavailable.title'),
    subtitle: t('exception_state.service_unavailable.subtitle'),
    illustration: EmptyState,
    textButton: t('exception_state.service_unavailable.text_button')
  }
})
